
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function SearchSection() {
  const [searchType, setSearchType] = useState('buy');
  const [propertyType, setPropertyType] = useState('');
  const [area, setArea] = useState('');
  const [priceRange, setPriceRange] = useState('');

  const propertyTypes = [
    { value: 'mansion', label: 'マンション' },
    { value: 'house', label: '一戸建て' },
    { value: 'land', label: '土地' },
    { value: 'investment', label: '投資用物件' }
  ];

  const areas = [
    { value: 'shibuya', label: '渋谷区' },
    { value: 'shinjuku', label: '新宿区' },
    { value: 'minato', label: '港区' },
    { value: 'setagaya', label: '世田谷区' },
    { value: 'meguro', label: '目黒区' }
  ];

  const priceRanges = [
    { value: '0-3000', label: '3,000万円以下' },
    { value: '3000-5000', label: '3,000万円〜5,000万円' },
    { value: '5000-8000', label: '5,000万円〜8,000万円' },
    { value: '8000-10000', label: '8,000万円〜1億円' },
    { value: '10000-', label: '1億円以上' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            物件検索
          </h2>
          <p className="text-lg text-gray-600">
            ご希望の条件で理想の物件を見つけましょう
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          {/* Search Type Toggle */}
          <div className="flex justify-center mb-8">
            <div className="bg-gray-100 rounded-full p-1 flex">
              <button
                onClick={() => setSearchType('buy')}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all cursor-pointer ${
                  searchType === 'buy' 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                購入
              </button>
              <button
                onClick={() => setSearchType('rent')}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all cursor-pointer ${
                  searchType === 'rent' 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                賃貸
              </button>
            </div>
          </div>

          {/* Search Form */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            {/* Property Type */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                物件種別
              </label>
              <div className="relative">
                <select
                  value={propertyType}
                  onChange={(e) => setPropertyType(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer"
                >
                  <option value="">選択してください</option>
                  {propertyTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
              </div>
            </div>

            {/* Area */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                エリア
              </label>
              <div className="relative">
                <select
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer"
                >
                  <option value="">選択してください</option>
                  {areas.map((areaOption) => (
                    <option key={areaOption.value} value={areaOption.value}>
                      {areaOption.label}
                    </option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
              </div>
            </div>

            {/* Price Range */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                価格帯
              </label>
              <div className="relative">
                <select
                  value={priceRange}
                  onChange={(e) => setPriceRange(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white pr-8 cursor-pointer"
                >
                  <option value="">選択してください</option>
                  {priceRanges.map((range) => (
                    <option key={range.value} value={range.value}>
                      {range.label}
                    </option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
              </div>
            </div>

            {/* Search Button */}
            <div className="flex items-end">
              <Button className="w-full">
                <i className="ri-search-line mr-2"></i>
                検索する
              </Button>
            </div>
          </div>

          {/* Quick Search Tags */}
          <div className="flex flex-wrap gap-2">
            <span className="text-sm text-gray-600 mr-2">人気の検索:</span>
            {['新築マンション', '駅近物件', 'ペット可', '投資用', 'リノベーション済み'].map((tag) => (
              <button
                key={tag}
                className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm hover:bg-blue-100 transition-colors cursor-pointer"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
